import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initSentry } from "./lib/sentry";

// Initialize Sentry as early as possible so unhandled errors during the
// app's startup phase are still captured. No-op when REACT_APP_SENTRY_DSN
// is not configured.
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
